export const CREATE_NOTIFICATION_REQUEST = "CREATE_NOTIFICATION_REQUEST";
export const GET_NOTIFICATION_SUBSCRIPTION_STATUS = "GET_NOTIFICATION_SUBSCRIPTION_STATUS";
export const CREATING_NOTIFICATION = "CREATING_NOTIFICATION";
